import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { TableColumn } from "react-data-table-component";
import { AiOutlineDelete } from "react-icons/ai";
import { FiEdit } from "react-icons/fi";
import {
  RiFileList2Line,
  RiAccountBoxFill,
  RiFileUserLine,
} from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import AlertModal from "../../../components/alertModal/alertModal";
import CustomBreadcrumb from "../../../components/customBreadcrumb/CustomBreadcrumb";
import DataTableBase from "../../../components/dataTableBase/DataTableBase";
import MainLoader from "../../../components/loading/MainLoader";
import Title from "../../../components/title/Title";
import TooltipPopup from "../../../components/tooltipPopup/TooltipPopup";
import PRIVILEGES from "../../../const/privilegesList";
import { IDataBundleUser } from "../../../interfaces/dataBundleUser";
import { ISuccessState } from "../../../interfaces/successState";
import {
  deleteExternalUser,
  getExternalUses,
} from "../../../store/actions/externalUser.action";
import { IRootState } from "../../../store/configureStore";
import hasPrivilege from "../../../util/hasPermission";
import styles from "./Users.module.scss";

const conditionalRowStyles = [
  {
    when: (row: IDataBundleUser) => {
      return row.active === true;
    },
    style: {
      backgroundColor: "#ffff",
      userSelect: "none" as "none",
    },
  },
  {
    when: (row: IDataBundleUser) => {
      return row.active === false;
    },
    style: {
      backgroundColor: "red",
      color: "white",
    },
  },
];

const Users = () => {
  const dispatch: any = useDispatch();
  const navigate = useNavigate();

  const [deletingUser, setDeletingUser] = useState<number | undefined>();
  const [isSuccess, setIsSuccess] = useState<ISuccessState | undefined>();

  const { loading, externalUsers, user, deletingExUser } = useSelector(
    ({ externalUser, privileges }: IRootState) => ({
      loading: externalUser.loading,
      error: externalUser.error,
      externalUsers: externalUser.dataBundle,
      user: privileges.dataBundleUser,
      deletingExUser: externalUser.deletingUser,
    })
  );

  useEffect(() => {
    dispatch(getExternalUses());
  }, [dispatch]);

  const addUserHandler = () => {
    navigate("/settings/users/add");
  };

  const roleOrder = ["USER ADMIN", "USER", "USER IT", "USER BILLING"];

  const sortedExternalUsers = externalUsers.slice().sort((a, b) => {
    const indexA = roleOrder?.indexOf(a.role?.name);
    const indexB = roleOrder?.indexOf(b.role?.name);

    if (indexA !== -1 && indexB !== -1) {
      return indexA - indexB;
    }

    if (indexA !== -1) {
      return -1;
    }
    if (indexB !== -1) {
      return 1;
    }

    return a?.role?.name.localeCompare(b.role?.name);
  });

  const deleteUserHandler = () => {
    if (!deletingUser || !user?.id) {
      return;
    }
    dispatch(deleteExternalUser(deletingUser, user?.id, setIsSuccess));
    setDeletingUser(undefined);
  };

  const columns: TableColumn<IDataBundleUser>[] = [
    {
      name: "User Name",
      // width:'13%',
      selector: (row: IDataBundleUser) => row?.username,
    },
    // {
    //   name: 'E-Mail',
    //   selector: (row: IDataBundleUser) => row.email,
    // },
    {
      name: "Name",
      selector: (row: IDataBundleUser) => `${row?.title}. ${row?.name}`,
    },

    {
      name: "Nick Name",
      width: "13%",
      selector: (row: IDataBundleUser) => row?.nickName,
    },
    {
      name: "Role",
      width: "13%",
      selector: (row: IDataBundleUser) => row?.role?.name,
    },
    {
      name: "Actions",
      cell: (row: IDataBundleUser) => (
        <>
          <Row
            className={[styles.actionIcons, "justify-content-center"].join(" ")}
          >
            {hasPrivilege(
              user?.role.privileges,
              PRIVILEGES.UPDATE_EXTERNAL_USER
            ) &&
              row?.role?.code !== "USER_ADMIN" && (
                <Col>
                  <TooltipPopup tooltip="Edit User">
                    <FiEdit
                      color="#105398"
                      onClick={() =>
                        navigate(`/settings/users/${row?.id}/update`)
                      }
                    />
                  </TooltipPopup>
                </Col>
              )}
            {/* {row?.role?.code !== "USER_ADMIN" && user?.id === row?.id && (
              <Col>
                <TooltipPopup tooltip="Edit User">
                  <FiEdit
                    color="#105398"
                    onClick={() =>
                      navigate(`/settings/users/${row?.id}/update`)
                    }
                  />
                </TooltipPopup>
              </Col>
            )} */}
            {hasPrivilege(
              user?.role?.privileges,
              PRIVILEGES.ASSIGN_PRIVILEGE
            ) && (
              <Col className={[styles.leftBorder].join(" ")}>
                <TooltipPopup tooltip="Assign Privileges">
                  <RiFileUserLine
                    color="#105398"
                    onClick={() =>
                      navigate(
                        `/settings/users/addPrivilege/${row?.id}/${row?.role?.id}`
                      )
                    }
                  />
                </TooltipPopup>
              </Col>
            )}
            {hasPrivilege(
              user?.role?.privileges,
              PRIVILEGES.ASSIGN_PRIVILEGE
            ) &&
              row?.role?.code !== "USER_ADMIN" && (
                <Col className={[styles.leftBorder].join(" ")}>
                  <TooltipPopup tooltip="Assign Circuit Group">
                    <RiFileList2Line
                      color="#105398"
                      onClick={() =>
                        navigate(
                          `/settings/users/assignCircuitGroup/${row?.id}/${row?.name}`
                        )
                      }
                    />
                  </TooltipPopup>
                </Col>
              )}{" "}
            {hasPrivilege(
              user?.role?.privileges,
              PRIVILEGES.ASSIGN_PRIVILEGE
            ) &&
              row?.role?.code !== "USER_ADMIN" && (
                <Col className={[styles.leftBorder].join(" ")}>
                  <TooltipPopup tooltip="Assign Account Numbers">
                    <RiAccountBoxFill
                      color="#105398"
                      onClick={() =>
                        navigate(
                          `/settings/users/assignAccountGroup/${row?.id}/${row?.name}`
                        )
                      }
                    />
                  </TooltipPopup>
                </Col>
              )}{" "}
            {hasPrivilege(
              user?.role?.privileges,
              PRIVILEGES.DELETE_EXTERNAL_USER
            ) &&
              row?.role?.code !== "USER_ADMIN" && (
                <Col className={[styles.leftBorder].join(" ")}>
                  <TooltipPopup tooltip="Delete">
                    <AiOutlineDelete
                      color="#FF6464"
                      onClick={() => setDeletingUser(row?.id)}
                    />
                  </TooltipPopup>
                </Col>
              )}
          </Row>
        </>
      ),
    },
  ];

  return (
    <div className="page-container">
      <MainLoader show={loading || deletingExUser} />
      <CustomBreadcrumb
        items={[
          { path: "/", title: "Home" },
          { path: "/settings/users", title: "Manage Users" },
        ]}
      />

      <Title>User List</Title>

      {hasPrivilege(user?.privileges, PRIVILEGES.ADD_USER) && (
        <Row className="justify-content-end mb-3">
          <Col className="col-auto">
            <div className={styles.btnAddUser} onClick={addUserHandler}>
              <div className={styles.icon}>
                <FontAwesomeIcon icon={faPlus} />
              </div>
              <span>Add User</span>
            </div>
          </Col>
        </Row>
      )}

      <DataTableBase
        className="mt-3"
        columns={columns}
        data={sortedExternalUsers}
        progressPending={loading}
        conditionalRowStyles={conditionalRowStyles}
        style={{ backgroundColor: "#f0f0f0" }}
      />

      <AlertModal
        show={!!deletingUser}
        buttons={[
          {
            variant: "danger",
            text: "OK",
            onClick: deleteUserHandler,
          },
          {
            variant: "success",
            text: "Cancel",
            onClick: () => {
              setDeletingUser(undefined);
            },
          },
        ]}
        variant="error"
      >
        Are you sure you want to delete external user? This action can not be
        reversed.
      </AlertModal>

      <AlertModal
        show={!!isSuccess}
        buttons={[
          {
            variant: "success",
            text: "OK",
            onClick: () => {
              setIsSuccess(undefined);
            },
          },
        ]}
        variant={isSuccess?.isSuccess ? "success" : "error"}
      >
        {isSuccess?.message}
      </AlertModal>
    </div>
  );
};

export default Users;
